import { ValueState } from '@ui5/webcomponents-react';
import { AttachmentToUpload } from 'hooks/useFilesForAttachments';
import {
  GetProjectDetailsQuery,
  GetProjectsByTranslationTypeQuery,
  TranslationType
} from 'generated/graphql';
import {
  IssueTypeOptions,
  NotSelectedTranslationType,
  TranslationTypeOptions
} from '../../../stores/interfaces/CommonQueryState';
import { BaseQueryState } from 'stores/interfaces/CreateQueryState';
import { UseQueryState } from 'urql';
import { GetState, SetState } from 'zustand';
import {
  commonBaseQueryInitialStateFields,
  commonBaseQueryInitialStateValueStates
} from './CommonBaseQuerySlice';

export const createBaseQueryInitialStateFields = {
  deadline: '',
  answerDeadline: '',
  selectedProject: -1,
  projectManager: '',
  qualityExpert: '',
  queryResponsible: '',
  selectedTranslationType: TranslationTypeOptions.NOT_SELECTED_TRANSLATION_TYPE,
  attachments: [],
  attachmentValueStateMessage: ''
};

export const createBaseQueryInitialStateValueStates = {
  deadlineValueState: ValueState.None,
  projectValueState: ValueState.None,
  attachmentValueState: ValueState.None
};

// Create
export const createBaseQueryInitialState = {
  ...createBaseQueryInitialStateFields,
  ...createBaseQueryInitialStateValueStates,
  projectNames: undefined,
  projectDetails: undefined
};

export const createBaseQuerySlice = (
  set: SetState<BaseQueryState>,
  get: GetState<BaseQueryState>
) => ({
  ...createBaseQueryInitialState,
  setDeadline: (value: string) => set(() => ({ deadline: value })),
  setAnswerDeadline: (value: string) => set(() => ({ answerDeadline: value })),
  setDeadlineValueState: (value: ValueState) => set(() => ({ deadlineValueState: value })),
  setSelectedProject: (value: number) => set(() => ({ selectedProject: value })),
  setProjectValueState: (value: ValueState) => set(() => ({ projectValueState: value })),
  setProjectManager: (value: string) => set(() => ({ projectManager: value })),
  setQualityExpert: (value: string) => set(() => ({ qualityExpert: value })),
  setQueryResponsible: (value: string) => set(() => ({ queryResponsible: value })),
  setSelectedTranslationType: (value: TranslationType | NotSelectedTranslationType) =>
    set(() => ({ selectedTranslationType: value })),
  setAttachments: (value: AttachmentToUpload[]) => set(() => ({ attachments: value })),
  setAttachmentValueState: (value: ValueState) => set(() => ({ attachmentValueState: value })),
  setAttachmentValueStateMessage: (value: string) =>
    set(() => ({ attachmentValueStateMessage: value })),
  setProjectNames: (value: UseQueryState<GetProjectsByTranslationTypeQuery>) =>
    set(() => ({ projectNames: value })),
  setProjectDetails: (value: UseQueryState<GetProjectDetailsQuery>) =>
    set(() => ({ projectDetails: value })),
  resetDataForNewQuery: (shouldResetProject: boolean) => {
    return set({
      sourceText: '',
      sourceTextValueState: ValueState.None,
      targetText: '',
      details: '',
      ...(shouldResetProject
        ? { selectedProject: -1 }
        : { selectedProject: get().selectedProject }),
      projectValueState: ValueState.None,
      selectedIssueType: IssueTypeOptions.NOT_SELECTED_ISSUE_TYPE,
      attachments: []
    });
  },
  resetAllData: () =>
    set({
      ...createBaseQueryInitialStateFields,
      ...createBaseQueryInitialStateValueStates,
      ...commonBaseQueryInitialStateFields,
      ...commonBaseQueryInitialStateValueStates
    })
});
